import { Box, HeadingProps, VStack } from '@chakra-ui/layout';
import { StyleProps } from '@chakra-ui/styled-system';
import { useMultiStyleConfig } from '@chakra-ui/system';
import React, { ReactElement } from 'react';

import { WLHeading } from '..';
import Overline from '../Overline';
export enum HeadlineDividerVariant {
  short = 'short',
  light = 'light',
  lightShort = 'lightShort',
}

interface HeadlineDividerProps extends StyleProps {
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  variant?: HeadlineDividerVariant;
  children?: ReactElement<any, any> | string;
}

const HeadlineDivider: React.FC<HeadlineDividerProps> = ({
  as = 'h2',
  children,
  variant,
  ...rest
}) => {
  const styles = useMultiStyleConfig('HeadlineDividerV2', { variant });

  return (
    <Box as="span" __css={styles.container} {...rest} margin={0}>
      <Box as="span" __css={styles.divider} />
      {children && <Overline>{children}&nbsp;</Overline>}
    </Box>
  );
};

export default HeadlineDivider;
